import LoggerService,{formatTrace} from '../../../services/LoggerService';
import INITIAL_STATE from './INITIAL_STATE';
import REDUCER_ACTIONS from './ACTIONS';

const LOG = LoggerService.getInstance();

const reducer = (
  state: any,
  action: any
) => {
	if (action.type === REDUCER_ACTIONS.SET_FROM_DATE) {
		const {from_date} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_FROM_DATE',{from_date}));
		return {...state,from_date};
	}
	if (action.type === REDUCER_ACTIONS.SET_TO_DATE) {
		const {to_date} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_TO_DATE',{to_date}));
		return {...state,to_date};
	}
	if (action.type === REDUCER_ACTIONS.SET_ACTIVITY_TYPES) {
		const {activity_types} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_ACTIVITY_TYPES',{activity_types}));
		return {...state,activity_types};
	}
	if (action.type === REDUCER_ACTIONS.SET_DIRECTION) {
		const {direction} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_DIRECTION',{direction}));
		return {...state,direction};
	}
	if (action.type === REDUCER_ACTIONS.SET_HUB) {
		const {hub} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_HUB',{hub}));
		return {...state,hub};
	}
	if (action.type === REDUCER_ACTIONS.SET_COLLABORATORS) {
		const {collaborators} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_COLLABORATORS',{collaborators}));
		return {...state,collaborators};
	}
	if (action.type === REDUCER_ACTIONS.SET_SKILLS) {
		const {skills} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_SKILLS',{skills}));
		return {...state,skills};
	}
	if (action.type === REDUCER_ACTIONS.SET_FUNCTIONS) {
		const {functions} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_FUNCTIONS',{functions}));
		return {...state,functions};
	}
	if (action.type === REDUCER_ACTIONS.SET_BILLING_CUSTOMERS) {
		const {billing_customers} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_BILLING_CUSTOMERS',{billing_customers}));
		return {...state,billing_customers};
	}
	if (action.type === REDUCER_ACTIONS.SET_AUDITED_CUSTOMERS) {
		const {audited_customers} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_AUDITED_CUSTOMERS',{audited_customers}));
		return {...state,audited_customers};
	}
	if (action.type === REDUCER_ACTIONS.SET_REFERENTIALS) {
		const {referentials} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_REFERENTIALS',{referentials}));
		return {...state,referentials};
	}
	if (action.type === REDUCER_ACTIONS.SET_REFERENTIAL_TYPES) {
		const {referential_types} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_REFERENTIAL_TYPES',{referential_types}));
		return {...state,referential_types};
	}
	if (action.type === REDUCER_ACTIONS.SET_OF_NUMBER) {
		const {of_number} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_OF_NUMBER',{of_number}));
		return {...state,of_number};
	}
	// return state;
	throw new Error(`No matching "${action.type}" action type`);
};

export {INITIAL_STATE};
export default reducer;
